import React from "react";
import { AiOutlineLayout } from 'react-icons/ai';
import { RiRefreshLine, RiCloudLine, RiShieldCheckLine, RiFileCodeLine, RiGitMergeLine } from 'react-icons/ri';


const IndustriesWeServe = () => {
  return (
    <div className=" bg-gray-100">
      <section className="py-5 ">
        <div className="container mx-auto px-4">
          <div className="flex flex-col mb-6 justify-center items-center lg:justify-center lg:flex-row md:mb-8">
            <h2 className="mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group md:text-left lg:text-center text-left sm:text-left">
              <span className="inline-block mb-1 sm:mb-4 mx-auto md:text-left lg:text-center text-left sm:text-left">
                Key Capabilities
              </span>
              <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
            </h2>
          </div>

          <div className="flex justify-center flex-wrap gap-8 mb-8 ">
            <FeatureCard
              icon={<AiOutlineLayout className="text-4xl text-blue-600" />}
              title="Visual Infrastructure Modeling "
              description="Drag-and-drop interface for designing infrastructure architectures without deep coding expertise."
            />
            <FeatureCard
              icon={<RiRefreshLine className="text-4xl text-blue-600" />}
              title="Consistent Deployments"
              description="Replace outdated instances automatically with new, stable versions, ensuring reliability and predictability."
            />
            <FeatureCard
              icon={<RiCloudLine className="text-4xl text-blue-600" />}
              title="Multi-Cloud Orchestration"
              description="Manage hybrid and multi-cloud environments with automated scaling and cost-optimization controls."
              // className="lg:hidden"
            />
            <FeatureCard
              icon={
                <RiShieldCheckLine className="text-4xl text-blue-600" />
              }
              title="Policy-Driven Compliance "
              description="Integrate security, governance, and compliance standards (e.g., SOC 2, GDPR, HIPAA) into infrastructure blueprints."
            />
            <FeatureCard
              icon={
                <RiFileCodeLine className="text-4xl text-blue-600" />
              }
              title="Auto-Generated Infrastructure-as-Code"
              description="Convert visual designs into Terraform, Pulumi, or AWS CloudFormation scripts for seamless deployments."
            />
            <FeatureCard
              icon={
                <RiGitMergeLine className="text-4xl text-blue-600" />
              }
              title="DevOps & GitOps Integration"
              description="Automate infrastructure lifecycle management by integrating AeroInfra Vue with CI/CD pipelines and version-controlled repositories."
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export function FeatureCard({ icon, title, description, className }) {
  return (
    <div
      className={`card bg-white p-6 rounded-lg shadow-md w-[450px]
    ${className ? className : ""}
    `}
    >
      <div className="flex items-center justify-center mb-4">{icon}</div>
      <h3 className="text-xl font-semibold mb-2 text-center">{title}</h3>
      <p className="text-gray-600 text-center">{description}</p>
    </div>
  );
}

export default IndustriesWeServe;
